import { c as _c } from "react/compiler-runtime";
// The one dot. Variants: a status colour (column heads: `color`, the status's own, hq.tasks.Status), or the
// live-updates state (`live`: green when connected, a hairline grey otherwise). Styles: book.css `.dot`.
import type { LiveStatus } from "@hq-org/kit-wasm";
type Props = {
  t?: string;
} & ({
  color: string | null;
  live?: never;
} | {
  live: LiveStatus;
  color?: never;
});
export function Dot(t0) {
  const $ = _c(8);
  const {
    t,
    color,
    live
  } = t0;
  if (live === undefined) {
    const t1 = color ?? "var(--mute)";
    let t2;
    if ($[0] !== t1) {
      t2 = {
        background: t1
      };
      $[0] = t1;
      $[1] = t2;
    } else {
      t2 = $[1];
    }
    let t3;
    if ($[2] !== t || $[3] !== t2) {
      t3 = <span className="dot" data-t={t} style={t2} />;
      $[2] = t;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  let t1;
  if ($[5] !== live || $[6] !== t) {
    t1 = <span className="dot" data-t={t} data-state={live} title={live} />;
    $[5] = live;
    $[6] = t;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}